// src/components/mafia/themes/registry.js

// 1. ЛУЧШИЕ (TOP 5)
export const bestThemes = [
    { id: 'noir-detective', name: 'Noir', desc: 'Классика нуара' },
    { id: 'modern-clean', name: 'Clean OS', desc: 'Идеальная читаемость' },
    { id: 'cyber-pro', name: 'Cyber Pro', desc: 'Футуристичный интерфейс' },
    { id: 'royal-poker', name: 'Royal', desc: 'Казино и золото' },
    { id: 'bauhaus-pop', name: 'Bauhaus', desc: 'Геометрия и стиль' },
];

// 2. ТЕСТ (Новые экспериментальные)
export const mainThemes = [
    { id: 'soft-focus', name: 'Soft Focus', desc: 'Мягкий беж' },
    { id: 'slate-matte', name: 'Slate', desc: 'Матовый темный' },
    { id: 'aero-pro', name: 'Aero', desc: 'Воздух и стекло' },
    { id: 'rounded-pop', name: 'Round Pop', desc: 'Округлые формы' },
    { id: 'e-ink', name: 'E-Ink', desc: 'Электронная бумага' },
    { id: 'velvet-night', name: 'Velvet', desc: 'Глубокий фиолетовый' },
    { id: 'cardstock', name: 'Cardstock', desc: 'Плотная карта' },
    { id: 'cardcolor', name: 'Cardcolor', desc: 'Цветной корешок' }, // <--- НОВАЯ
    { id: 'frost-panel', name: 'Frost', desc: 'Ледяная панель' },
    { id: 'retro-ui', name: 'Win 95', desc: 'Ретро интерфейс' },
    { id: 'smooth-plastic', name: 'Plastic', desc: 'Гладкий пластик' },
];

// 3. АРХИВ 2 (Бывшие основные)
export const archive2Themes = [
    { id: 'neo-brutal', name: 'Neo-Pop', desc: 'Архив: Яркий' },
    { id: 'kraft-paper', name: 'Kraft', desc: 'Архив: Картон' },
    { id: 'cyber-lite', name: 'Cyber Lite', desc: 'Архив: Техно' },
    { id: 'sketch-book', name: 'Sketch', desc: 'Архив: Рисунок' },
    { id: 'soft-clay', name: 'Clay 3D', desc: 'Архив: Пластик' },
    { id: 'frosted-glass', name: 'Frosted', desc: 'Архив: Матовый' },
    { id: 'swiss-design', name: 'Swiss', desc: 'Архив: Типографика' },
    { id: 'denim-jean', name: 'Denim', desc: 'Архив: Джинс' },
    { id: 'carbon-fiber', name: 'Carbon', desc: 'Архив: Карбон' },
    { id: 'arcade-cabinet', name: 'Arcade', desc: 'Архив: Аркада' },
    { id: 'marble-lux', name: 'Marble', desc: 'Архив: Мрамор' },
    { id: 'blueprint-tech', name: 'Blueprint', desc: 'Архив: Чертеж' },
    { id: 'watercolor', name: 'Aquarelle', desc: 'Архив: Акварель' },
    { id: 'hacker-term', name: 'Console', desc: 'Архив: Терминал' },
    { id: 'sticker-bomb', name: 'Street', desc: 'Архив: Стикеры' },
    { id: 'vintage-post', name: 'Postal', desc: 'Архив: Винтаж' },
    { id: 'aurora-grad', name: 'Aurora', desc: 'Архив: Градиент' },
    { id: 'poker-felt', name: 'Casino', desc: 'Архив: Сукно' },
    { id: 'glitch-punk', name: 'Glitch', desc: 'Архив: Глитч' },
    { id: 'ceramic-clean', name: 'Ceramic', desc: 'Архив: Керамика' },
    { id: 'news-print', name: 'Gazette', desc: 'Архив: Газета' },
    { id: 'tactile-paper', name: 'Journal', desc: 'Архив: Дневник' },
    { id: 'glass-morphism', name: 'Glass Pro', desc: 'Архив: Стекло Pro' },
    { id: 'dark-matter', name: 'Matter', desc: 'Архив: Темный Pro' },
    { id: 'cinematic', name: 'Cinema', desc: 'Архив: Кино' },
    { id: 'comic-ink', name: 'Sin City', desc: 'Архив: Комикс' },
];

// 4. АРХИВ 1 (Самые старые)
export const archiveThemes = [
    { id: 'paper', name: 'Old Paper', desc: 'Архив 1: Бумага' },
    { id: 'minimal', name: 'V1 Minimal', desc: 'Архив 1: Минимализм' },
    { id: 'dark', name: 'V1 Dark', desc: 'Архив 1: Темный' },
    { id: 'wood', name: 'Wood', desc: 'Архив 1: Дерево' },
    { id: 'slate', name: 'Slate', desc: 'Архив 1: Камень' },
    { id: 'leather', name: 'Leather', desc: 'Архив 1: Кожа' },
    { id: 'blueprint', name: 'Blueprint V1', desc: 'Архив 1: Чертеж' },
    { id: 'gradient', name: 'Gradient', desc: 'Архив 1: Градиент' },
    { id: 'terminal', name: 'Terminal V1', desc: 'Архив 1: DOS' },
    { id: 'tactical', name: 'Tactical', desc: 'Архив 1: Милитари' },
    { id: 'neon', name: 'Neon', desc: 'Архив 1: Неон' },
    { id: 'glass', name: 'Glass V1', desc: 'Архив 1: Стекло' },
    { id: 'gothic', name: 'Gothic', desc: 'Архив 1: Готика' },
    { id: 'pop', name: 'Pop Art', desc: 'Архив 1: Поп-арт' },
    { id: 'western', name: 'Western', desc: 'Архив 1: Вестерн' },
    { id: 'scifi', name: 'Sci-Fi', desc: 'Архив 1: Космос' },
    { id: 'pixel', name: 'Pixel', desc: 'Архив 1: Пиксели' },
    { id: 'noir', name: 'Noir', desc: 'Архив 1: Нуар' },
    { id: 'royal', name: 'Royal', desc: 'Архив 1: Роял' },
    { id: 'lovecraft', name: 'Eldritch', desc: 'Архив 1: Мистика' },
];